import { FC } from "react"

interface ChatHeaderProps {
  messageCount: number
  enableChat?: boolean
  onToggleChat?: (enabled: boolean) => void
}

export const ChatHeader: FC<ChatHeaderProps> = ({ messageCount, enableChat, onToggleChat }) => {
  return (
    <>
      {!enableChat && onToggleChat && (
        <div className="mb-4 flex items-center justify-between px-3 py-2.5 bg-amber-50 dark:bg-transparent dark:bg-amber-900/15 border border-amber-200 dark:border-amber-800/40 rounded-lg">
          <span className="text-sm font-medium text-amber-700 dark:text-amber-300">Chat is currently disabled for players</span>
          <button
            onClick={() => onToggleChat(true)}
            className="px-3 py-1.5 text-xs font-medium bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-all"
          >
            Enable Chat
          </button>
        </div>
      )}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Tournament Chat</h3>
          <span className="text-sm text-gray-500 dark:text-gray-400">
            {messageCount} message{messageCount !== 1 ? "s" : ""}
          </span>
          {enableChat && onToggleChat && (
            <button
              onClick={() => onToggleChat(false)}
              className="px-2.5 py-1 text-[11px] font-medium text-rose-600 dark:text-rose-400 border border-rose-200 dark:border-rose-800/40 rounded-md hover:bg-rose-50 dark:hover:bg-rose-900/20 transition-all"
            >
              Disable Chat
            </button>
          )}
        </div>
      </div>
    </>
  )
}
